import React from "react";
import { connect } from "react-redux";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import LiveChat from "./LiveChat";
import Ticket from "./Ticket";
import SelectTicketModal from "./SelectTicketModal";
import chat_png from "../../assets/media/chat.png";
import write_png from "../../assets/media/chatsuite/write.png";
import "./index.css";

class AdminSupport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chatdiv_visible: false,
      loading: true,
      supports: [],
      brand_data: null,
      ticket_id_shouldOpen: "",
    };
  }
  componentDidMount() {
    if (!this.props.location.state) {
      this.props.history.push("/");
    } else {
      const { brand, role, username, ticket_id } = this.props.location.state;
      this.setState({ username, role, brand });
      if (this.props.brand) {
        this.loadState(this.props.brand);
      } else
        Firebase.getBrandDataByID(brand, (brand_data) => {
          brand_data.id = brand;
          this.loadState(brand_data);
        });
      // get All admin support
      Firebase.getAdminSupport(brand, (res) => {
        if (res) {
          let supports = Object.keys(res).map((id) => {
            return {
              id: id,
              ...res[id],
            };
          });

          this.setState({ supports }, () => {
            if (ticket_id) {
              let item = supports.find((support) => support.id === ticket_id);
              this.onSelectTicket(item);
            }
          });
        }
      });
    }
  }
  loadState = (brand_data) => {
    this.setState({
      brand_data: brand_data,
      logo: brand_data.logo,
      icon: brand_data.icon,
      brand_name: brand_data.name,
      brand_url: brand_data.url,
      hex: brand_data.hex,
      loading: false,
      is_property_brand: brand_data.is_property_brand
        ? brand_data.is_property_brand
        : false,
    });
  };

  showTickets = () => {
    const { brand_unreads } = this.props;

    let { supports } = this.state;
    supports.sort((a, b) => {
      if (a.time < b.time) return 1;
      else return -1;
    });
    return supports.map((item) => {
      const isNew = brand_unreads.map((unread) => unread.id).includes(item.id);
      return (
        <Ticket
          key={item.id}
          isNew={isNew}
          data={item}
          onSelect={() => this.onSelectTicket(item)}
        />
      );
    });
  };
  onSelectTicket = (ticket) => {
    const { brand } = this.state;
    this.setState({ ticket, chatdiv_visible: true });
    Firebase.readBrandUnReadMessage(brand, ticket.id);
  };
  goBack = () => {
    this.props.history.goBack();
  };
  onOpenTicket = async (ticket) => {
    const { brand } = this.state;
    const type = ticket.value;
    const openedBy = localStorage.getItem("uid");
    const time = new Date().getTime().toString();
    Firebase.createAdminSupport(brand, { type, time, openedBy });
  };
  render() {
    const {
      brand,
      logo,
      chatdiv_visible,
      ticket,
      brand_name,
      icon,
      loading,
      brand_data,
      is_property_brand,
    } = this.state;

    const username = this.props.location.state.username;
    const role = this.props.location.state.role;
    return (
      <div id="page-container">
        <Header
          username={username}
          role={role}
          onHome={this.goBack}
          logo={logo}
          brand={brand}
          brandName={brand_name}
          is_property_brand={is_property_brand}
        />
        <div className="second-header">
          <div className="col-md-7 col-lg-7 col-xl-7 heading_pane">
            <p>Technical and community management support</p>
          </div>
          <div className="col-md-5 col-lg-5 col-xl-5">
            <div className="btn-div">
              <p>New support ticket</p>
              <button data-toggle="modal" data-target="#select_ticket_modal">
                <img src={write_png} width="30" height="30" />
              </button>
            </div>
          </div>
        </div>
        <div
          className="row no-gutters flex-md-10-auto"
          style={{ position: "fixed", width: "100%", height: "100%", top: 127 }}
        >
          <div
            className="col-md-7 col-lg-7 col-xl-7 bg-body-dark"
            style={{ padding: 15, height: "90%", overflow: "scroll" }}
          >
            <div className="content content-full">
              {loading ? (
                <div className="loading-spinner">
                  <i className="fa fa-3x fa-sync fa-spin text-muted" />
                  <p>Fetching tickets...</p>
                </div>
              ) : (
                <div className="block block-fx-pop">{this.showTickets()}</div>
              )}
            </div>
          </div>
          <div className="col-md-5 col-lg-5 col-xl-5" style={{ height: "87%" }}>
            {chatdiv_visible ? (
              <LiveChat
                brand={{ ...brand_data, id: brand }}
                ticket={ticket}
                icon={icon}
                username={username}
              />
            ) : (
              <div className="empty_chat">
                <img src={chat_png} alt="chat" />
                <p>
                  Select a chat ticket or start <br />
                  a new chat, to engage with <br />
                  your community members.
                </p>
              </div>
            )}
          </div>
        </div>
        <SelectTicketModal onOpenTicket={this.onOpenTicket} />
      </div>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    brand: state.brand,
    brand_unreads: state.brand_unreads,
    unreads: state.unreads,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(AdminSupport);



// WEBPACK FOOTER //
// ./src/screens/AdminSupport/index.js